module.exports = __webpack_public_path__ + "img/logo.8bd24708.png";